import React from "react";
import Subheading from "../Common/Subheading";
import BillingDetailsIcon from "../../assets/icons/invoice_history.svg2";
import CreateSolutionModal from "../Library/CreateSolutionModal";
import { Col, Row } from "react-bootstrap";
import SolutionsBuilderLandingPage from "../SolutionsBuilder/SolutionsBuilderLandingPage";
import { Link } from "react-router-dom";
import MyIcon from "../Common/MyIcon";
import EditIcon from "../../assets/icons/Icon_Library/application icons/general/edit.svg2";

export default function SystemAdminSettings({ editedSolution }) {
  return (
    <div>
      <Subheading
        Icon={BillingDetailsIcon}
        heading="System Admin Settings"
        subheading="Your pre-defined System Admin settings"
      />
      <Row>
        <Col>
          <Link to={`/library/solutions/new/edit`}>
            <div className="d-flex align-items-center">
              <MyIcon Icon={EditIcon} width={20} className="rounded-3" />
              <span className="ms-2 fw-bold text-navy">
                Create New Solution
              </span>
            </div>
          </Link>
        </Col>
      </Row>
    </div>
  );
}
